import React, { PropsWithChildren } from 'react';

import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'FixedContentOnXs';

const TOP_MENU_HEIGHT = 64;
const ADDITIONAL_OFFSET = 16;
const DEFAULT_BOTTOM_OFFSET = 154;

interface Props {
	className?: string;
	noShadow?: boolean;
	isSheet?: boolean;
	light?: boolean;
	ignoreKeyboard?: boolean;
}

function FixedContentOnXs(props: PropsWithChildren<Props>): JSX.Element {
	const { className, noShadow, isSheet, light, ignoreKeyboard, children } = props;
	return (
		<div className={bm(MODULE_NAME, { noShadow, isSheet, light, ignoreKeyboard }, className)}>
			{children}
		</div>
	);
}

export function useScrollOverFixedContentOnXs(enabled: boolean): { onFocus: () => void } {
	return {
		onFocus: () => {
			if (!enabled) return;

			setTimeout(() => {
				const el = document.activeElement instanceof HTMLElement ? document.activeElement : null;
				if (!el) return;

				const scrollContainer = document.querySelector(
					'.MobileAppLayout-content'
				) as HTMLElement | null;
				if (!scrollContainer) return;

				if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;

				const fixedWrapper = document.querySelector(`.${MODULE_NAME}`) as HTMLElement | null;
				const bottomOffset = fixedWrapper ? fixedWrapper.offsetHeight : DEFAULT_BOTTOM_OFFSET;
				const containerPaddingTop =
					parseFloat(window.getComputedStyle(scrollContainer).paddingTop || '0') || 0;

				const containerRect = scrollContainer.getBoundingClientRect();
				const elRect = el.getBoundingClientRect();

				const offsetTop = elRect.top - containerRect.top + scrollContainer.scrollTop;
				const elBottom = elRect.bottom - containerRect.top + scrollContainer.scrollTop;

				let desiredTop = Math.max(
					0,
					offsetTop - TOP_MENU_HEIGHT - ADDITIONAL_OFFSET - containerPaddingTop
				);

				const visibleBottom = scrollContainer.clientHeight - bottomOffset;
				if (elBottom - desiredTop > visibleBottom) {
					desiredTop = elBottom - visibleBottom;
				}

				desiredTop = Math.max(
					0,
					Math.min(desiredTop, scrollContainer.scrollHeight - scrollContainer.clientHeight)
				);
				scrollContainer.scrollTo({ top: desiredTop, behavior: 'smooth' });
			}, 600);
		},
	};
}

export default FixedContentOnXs;
